import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import dayjs from 'dayjs';

export interface SuiviInterventionState {
    interventions: InterventionNonPreventive[];

    tableHeader: TableHeader[];

    page: number;
    nbOfPages: number;
    scroll: number;
    count: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };

    filterSite: Array<number>;
    filterStatus: Array<string>;
    filterInterventionId: string;
    filterPredictedDateFrom: string;
    filterPredictedDateTo: string;

    isLoading: boolean;
    error?: Error;
    success: boolean;

    isExportXlsLoading: boolean;
}

export const initialState: SuiviInterventionState = {
    interventions: [],

    tableHeader: [
        {
            label: 'intervention.id',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'intervention.objet',
            sortData: 'objet',
            sortStatus: SortType.NONE,
            width: '24%',
        },
        {
            label: 'intervention.request.type',
            sortData: 'type',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'intervention.dateDebutPrevue',
            sortData: 'dateDebutPrevue',
            sortStatus: SortType.DESC,
            width: '10%',
        },
        {
            label: 'intervention.dateDebut',
            sortData: 'dateDebutReelle',
            sortStatus: SortType.NONE,
            width: '9%',
        },
        {
            label: 'intervention.dateFin',
            sortData: 'dateFinReelle',
            sortStatus: SortType.NONE,
            width: '9%',
        },
        {
            label: 'intervention.libelleProjet',
            sortData: 'libelleProjet',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        },
        {
            label: 'dataList.alarmante',
            sortData: 'isAlarmante',
            sortStatus: SortType.INACTIVE,
            width: '5%',
            regleCle: 'suiviInterventionsNonPreventives.alarmante',
        },
        {
            label: 'intervention.request.status',
            sortData: 'etat',
            sortStatus: SortType.NONE,
            width: '9%',
            regleCle: 'suiviInterventionsNonPreventives.statuts',
        },
        {
            label: 'intervention.request.pdf',
            sortData: 'pdfExist',
            sortStatus: SortType.INACTIVE,
            width: '4%',
            regleCle: 'suiviInterventionsNonPreventives.rapportDisponible',
        },
    ],

    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'dateDebutPrevue',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    filterStatus: [],
    filterInterventionId: '',
    filterPredictedDateFrom: dayjs().add(-1,'y' ).format('YYYY-MM-DD'),
    filterPredictedDateTo: dayjs().format('YYYY-MM-DD'),

    isLoading: false,
    success: false,

    isExportXlsLoading: false,
};

export const state: SuiviInterventionState = {
    ...initialState,
};
